
import { Component, OnInit, ViewEncapsulation, OnDestroy, Input, ChangeDetectionStrategy, SimpleChanges, OnChanges } from '@angular/core';
import { TreeNode } from 'primeng/api';

@Component({
    selector: 'app-alm-attribute-ladder-table',
    templateUrl: './alm-attribute-ladder-table.component.html',
    styleUrls: ['./alm-attribute-ladder-table.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ALMAttributeLadderTableComponent implements OnInit, OnDestroy, OnChanges {
    @Input()
    ladderTreeNodes: TreeNode[];
    @Input()
    ladderColumnNames: string[];
    @Input()
    showDelta = false;
    initialized = false;

    constructor() {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.initialized = false;
        this.initialized = true;
    }
    ngOnDestroy() {
    }
}
